export enum UserDashboardPublicationTab {
    Favorites,
    Offline,
    New,
}
